<template>
  <Header />
  <main>
    <slot />
  </main>
  <Footer v-if="!hideFooter" />
</template>

<script setup lang="ts">
import Header from "~/layouts/Header/Header.vue";
import Footer from "~/layouts/Footer/Footer.vue";
import { useDisclosure } from '@storefront-ui/vue';
import { DefaultLayoutProps } from '~/layouts/types';
import { useRoute } from 'vue-router';

defineProps<DefaultLayoutProps>();

const route = useRoute();
const hideFooter = computed(() => route.path.startsWith('/my-account'));

const { isOpen: isAccountDropdownOpen, toggle: accountDropdownToggle } = useDisclosure();
const { isOpen: isSearchModalOpen, open: searchModalOpen, close: searchModalClose } = useDisclosure();

const { fetchCart, data: cart } = useCart();
const { fetchCustomer, data: account } = useCustomer();

fetchCart();
fetchCustomer();

usePageTitle();

const cartLineItemsCount = computed(() =>
  cart.value?.lineItems.reduce((total, { quantity }) => total + quantity, 0) ?? 0
);

const accountDropdown = [
  {
    label: 'account.heading',
    link: paths.account,
  },
  {
    label: 'account.ordersAndReturns.section.myOrders',
    link: paths.accountMyOrders,
  },
  {
    label: 'account.ordersAndReturns.section.returns',
    link: paths.accountReturns,
  },
  {
    label: 'account.logout',
    link: '/',
  },
];
const NuxtLink = resolveComponent('NuxtLink');
</script>
